(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charlox-product-nav"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('charlox-product-tools')) {
  customElements.define('charlox-product-tools', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('nav');
      this.indicator = this.nav.querySelector('[data-charlox-nav-indicator]');
      this.frame = 0;
      this.reviewSortInitialized = false;
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.onClick = event => {
        const badge = event.target.closest('.jdgm-preview-badge, .jdgm-prev-badge');
        const link = event.target.closest('.charlox-product-nav a');
        const reviewTarget = document.querySelector('charlox-review-pages[data-ready]') || document.getElementById('judgeme_product_reviews');
        const target = badge || link?.getAttribute('href') === '#judgeme_product_reviews' ? reviewTarget : link ? document.querySelector(link.getAttribute('href')) : null;
        if (target) {
          event.preventDefault();
          event.stopPropagation();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }
        this.refresh();
      };
      this.onKey = event => {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.jdgm-prev-badge__text')) this.onClick(event);
      };
      document.addEventListener('click', this.onClick, true);
      document.addEventListener('keydown', this.onKey);
      window.addEventListener('resize', this.refresh);
      window.addEventListener('scroll', this.refresh, { passive: true });
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(document.getElementById('MainContent'), { childList: true, subtree: true });
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(document.getElementById('MainContent'));
      this.refresh();
    }
    update() {
      const hero = document.querySelector('[id^="MainProduct-"]');
      this.nav.hidden = this.dataset.navigation !== 'true' || !hero || hero.getBoundingClientRect().bottom > 70;
      const badge = document.querySelector('.product__info-container .jdgm-prev-badge');
      const badgeText = badge?.querySelector('.jdgm-prev-badge__text');
      if (badgeText) {
        const count = badge.dataset.numberOfReviews;
        const label = `(${count}) Avis`;
        if (count && badgeText.textContent !== label) badgeText.textContent = label;
        badgeText.setAttribute('role', 'link');
        badgeText.tabIndex = 0;
      }
      const sort = document.querySelector('.jm-review-widget .jdgm-sort-dropdown');
      const reviewSettings = document.querySelector('[data-charlox-reviews]');
      const photosFirst = reviewSettings?.dataset.photosFirst ?? this.dataset.photosFirst;
      if (this.reviewPhotosFirst !== photosFirst) {
        if (this.reviewPhotosFirst !== undefined && photosFirst !== 'true' && sort?.value === 'pictures_first') {
          sort.value = 'created_at';
          sort.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.reviewSortInitialized = false;
        this.reviewPhotosFirst = photosFirst;
      }
      if (!this.reviewSortInitialized && sort?.querySelector('option[value="pictures_first"]')) {
        this.reviewSortInitialized = true;
        if (photosFirst === 'true' && sort.value === 'created_at') {
          sort.value = 'pictures_first';
          sort.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const targets = [...this.nav.querySelectorAll('a')].map(link => ({ link, target: link.getAttribute('href') === '#judgeme_product_reviews' ? document.querySelector('charlox-review-pages[data-ready]') || document.getElementById('judgeme_product_reviews') : document.querySelector(link.getAttribute('href')) })).filter(item => item.target);
      let current = targets[0];
      targets.forEach(item => { if (item.target.getBoundingClientRect().top <= 180) current = item; });
      targets.forEach(item => { if (item === current) item.link.setAttribute('aria-current', 'location'); else item.link.removeAttribute('aria-current'); });
      if (!this.nav.hidden && current && this.indicator) {
        const bar = this.nav.getBoundingClientRect();
        const active = current.link.getBoundingClientRect();
        this.indicator.style.width = `${active.width}px`;
        this.indicator.style.height = `${active.height}px`;
        this.indicator.style.transform = `translate3d(${active.left - bar.left}px,${active.top - bar.top}px,0)`;
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      document.removeEventListener('click', this.onClick, true);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.refresh);
      window.removeEventListener('scroll', this.refresh);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charlox-quiz-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('charlox-quiz-guide')) {
  customElements.define('charlox-quiz-guide', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const invite = this.querySelector('.cq-guide-invite');
      const key = 'charlox-quiz-guide-until-v1';
      const readUntil = () => {
        try { return Number(localStorage.getItem(key) || 0); } catch { return Date.now() + 1; }
      };
      const snooze = days => {
        try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {}
        invite.hidden = true;
      };
      this.querySelector('.cq-guide-dismiss')?.addEventListener('click', () => snooze(Number(this.dataset.snooze) || 7), {signal});
      document.addEventListener('click', event => {
        const link = event.target.closest?.('a[href="#quiz"]');
        if (link) snooze(30);
      }, {signal});
      if (this.dataset.editor === 'true' || this.dataset.invitation !== 'true' || !matchMedia('(min-width: 1000px) and (pointer: fine)').matches) return;
      const start = Date.now();
      let engaged = false;
      window.addEventListener('scroll', () => {
        const total = document.documentElement.scrollHeight - innerHeight;
        if (total > 0 && scrollY / total * 100 >= Number(this.dataset.scroll)) engaged = true;
      }, {signal, passive: true});
      document.addEventListener('mouseout', event => {
        if (event.relatedTarget || event.clientY > 10 || !engaged || Date.now() - start < Number(this.dataset.delay) * 1000 || readUntil() > Date.now()) return;
        const modalOpen = Array.from(document.querySelectorAll('[role="dialog"], dialog[open], [aria-label="Quiz"]')).some(element => {
          const style = getComputedStyle(element);
          const rect = element.getBoundingClientRect();
          return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
        });
        if (modalOpen || document.body.style.overflow === 'hidden') return;
        snooze(Number(this.dataset.snooze) || 7);
        invite.hidden = false;
      }, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
